import { ApiDictionary } from '../http'

import WorkshopData from './workshop-registration-list.json' 
import ActiveWorkshops from './workshop-registration-activeworkshops.json'
import Dictionaries from './collections-getdictionaries.json'
import Participant from './workshop-participant-get.json'
import ParticipantWithPriorGuests from './workshop-participant-get-WithPriorGuests.json'
import RegistrationSuccess from './workshop-participant-save-success.json'
import DeregistrationSuccess from './workshop-participant-delete.json'
import RegistrationMenu from './workshop-getregistrationmenu.json'
import SessionUpdate from './public-sessionupdate.json'

export const mockApi: ApiDictionary<string> = {
	'/workshop/registration/list': JSON.stringify(WorkshopData, null, 2),
	'/workshop/registration/activeworkshops': JSON.stringify(ActiveWorkshops, null, 2), 
	'/workshop/getregistrationmenu': JSON.stringify(RegistrationMenu, null, 2), 
	'/collections/getdictionaries': JSON.stringify(Dictionaries, null, 2), 
	'/workshop/participant/get': JSON.stringify(ParticipantWithPriorGuests, null, 2), 
	'/workshop/participant/save': JSON.stringify(RegistrationSuccess, null, 2), 
	'/workshop/participant/delete': JSON.stringify(DeregistrationSuccess, null, 2), 
	// '/public/logout': '', // server performs a 302 redirect
	'/workshop/registration': '', // api returns error after trying to parse html as json
	'/public/renewsession': 'ok', 
	'/public/sessionupdate': JSON.stringify(SessionUpdate, null, 2),
}

export default mockApi